import AuthStore from "@helper/auth/auth-store";
import { i18n } from "next-i18next";

import { ISO3166_ALPHA2 } from "../constants/language";

export const getIso3166Alpha2 = () => {
    const user = AuthStore.getState()?.user;
    if (user) {
        return ISO3166_ALPHA2[user.language] || ISO3166_ALPHA2.eng;
    }

    switch (i18n.language) {
        case "de":
            return "de-DE";
        case "en":
            return "en-US";
        default:
            return "en-US";
    }
};
